import { all, put, select, takeEvery } from 'redux-saga/effects';
import { HTTPError } from 'services/api/entities';

import { tagService } from 'services/api';
import type { ITag } from 'services/api/entities';
import { TagType } from 'services/api/responses/responseTypes';
import { startAction, stopAction, errorAction } from '../base/actions';
import { normalizeTags } from '../helpers/normalizeTags';
import {
  tagGetListSuccess,
  tagActionNames,
  tagSelectionFromURLSuccess,
} from './actions';
import { TagStore } from './types';

function* getTagList(tagType: TagType) {
  const tagList: Array<ITag> = yield tagService.getList(tagType);

  const tags = normalizeTags(tagList);

  yield put(
    tagGetListSuccess({ tags: tags.entities, tagIds: tags.ids, tagType })
  );
}

function* getMultipleTagLists(tagTypes: Array<TagType>) {
  const tagStore: TagStore = yield select((state) => state.tags);

  yield all(
    tagTypes
      .filter(
        (tagType) =>
          // Check if store has key = tagType
          !tagStore[tagType]
      )
      .map((tagType) => getTagList(tagType))
  );
}

export function* asyncGetTagList(action: {
  type: string;
  payload: { tagType: TagType };
}) {
  const { tagType } = action.payload;
  yield put(startAction(action));
  try {
    yield getTagList(tagType);
  } catch (error) {
    yield put(errorAction({ type: action.type, payload: error as HTTPError }));
  } finally {
    yield put(stopAction(action));
  }
}

export function* asyncSelectTagsFromURL(action: {
  type: string;
  payload: { selectedTags: Record<string, Array<string>> };
}) {
  const { selectedTags } = action.payload;

  yield put(startAction(action));

  try {
    yield getMultipleTagLists(Object.keys(selectedTags) as Array<TagType>);
    yield put(tagSelectionFromURLSuccess({ selectedTags }));
  } catch (error) {
    yield put(errorAction({ type: action.type, payload: error as HTTPError }));
  } finally {
    yield put(stopAction(action));
  }
}
/* ----------------------------------------------------------------------------------------
 * Watch sagas
 * ----------------------------------------------------------------------------------------*/

function* watchGetTagList() {
  yield takeEvery(tagActionNames.TAG_GET_LIST, asyncGetTagList);
}

function* watchTagSelectionFromURL() {
  yield takeEvery(
    tagActionNames.TAG_SELECTION_FROM_URL,
    asyncSelectTagsFromURL
  );
}

export default function* rootSaga() {
  yield all([watchGetTagList(), watchTagSelectionFromURL()]);
}
